import SafetyClassification from '@/components/product-presentation/product-filters/safety-classification/safety-classification.vue';
import Dimensions from '@/components/product-presentation/product-filters/dimensions/dimensions.vue';
const ProductFilters = {
  // Props
  props: [
  ],
  components: {
    'safety-classification': SafetyClassification,
    'dimensions': Dimensions
  },
  // Computed
  computed: {
  }

}

export default ProductFilters
